import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import TextInput from '../../../../components/ZUILib/TextInput';
import InputButton from '../../../../components/ZUILib/InputButton';
import ModalPopover from '../../../../components/ZUILib/ModalPopover';
import CheckBox from '../../../../components/ZUILib/CheckBox';
import Warning from '../../../../components/Warning';
import commonUtil from '../../../../utils/commonUtil';
import serverClientUtil from '../../../../utils/serverClientUtil';
import errorLables from '../../../../utils/errors/LP_GR_error.json';
import * as defaultConst from '../../../../../src//utils/clientConstant';
import Tagging from '../../../../components/Tagging';

const applicationRoutes = commonUtil.getApplicationRoutes();

class LoginModal extends Component {

  showLoginModal = () => {
    this.warning.setMessage('');
    this.login.setControlState(true, '', { controlErrorClass: 'error', errorClass: 'error' });
    this.password.setControlState(true, '', { controlErrorClass: 'error', errorClass: 'error' });
    this.loginModal.handleShow();
  }
  constructor() {
    super();
    this.clickHandlerForgotPassword = this.clickHandlerForgotPassword.bind(this);
    this.warningMessage = null;
    this.loggedIn = '';
    this.toggleRemeberMeMessage = this.toggleRemeberMeMessage.bind(this);
  }
  clickHandlerForgotPassword = () => {
    const _url = serverClientUtil.getLPFullURL() + '/users/forgotPassword?login=';
    window.open(_url);
  }
  showRemeberMe = false
  loginForm = {
    login: '',
    password: '',
    autoLoginCheckbox: '',
  }
  isValueAvailable = (str) => {
    if (str && str.trim()) {
      return true;
    }
    return false;
  }
  validate = () => {
    const emailValidationRules = [
      { functionRef: this.isValueAvailable, funcData: [this.login.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.email.required') },
      { functionRef: commonUtil.validateEmail, funcData: [this.login.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.email.invalid') },
    ];

    const passwordValidationRiles = [
      { functionRef: this.isValueAvailable, funcData: [this.password.getValue()], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.password.required') },
      { functionRef: commonUtil.validatePassword, funcData: [this.password.getValue(), 8], errorMessage: commonUtil.getError(errorLables.createAccount, 'ca.login.password.invalid') },
    ];

    const isLoginValid = commonUtil.validateTextInput(emailValidationRules, this.login, null);
    const isPasswordValid = commonUtil.validateTextInput(passwordValidationRiles, this.password, null);

    if (isLoginValid && isPasswordValid) {
      this.loginForm.login = this.login.getValue();
      this.loginForm.password = this.password.getValue();
      this.loginForm.autoLoginCheckbox = this.userAutoLogingChk.isChecked() ? 'true' : 'false';
    }

    const { login, password } = this.loginForm;
    if (login && password) {
      return true;
    }
    return false;
  }
  redirectCreateAccountPage = () => {
    browserHistory.push(applicationRoutes.register);
    this.loginModal.handleHide();
  }
  handleLoginOnEnter = (e) => {
    if (e.key === 'Enter' && this.validate()) {
      this.handleUserLogin();
    }
  }
  getTaggingData = (data, URL) => {
    const _dataLayer = {};
    const _loginInfo = {};

    _dataLayer.event = 'Login';
    _dataLayer.category = 'Login';
    _loginInfo.url = URL;
    _dataLayer.login = commonUtil.getUserInfo(data);

    return _dataLayer;
  }

  handleUserLogin = () => {
    const that = this;
    function checkAuth() {
      const data = that.props.myProps && that.props.myProps.user && that.props.myProps.user.data ? that.props.myProps.user.data : that.props.myProps.user;
      const eventDetails = data && data.result && data.result.myEventDetail;


      if (data && data.result && data.result.status && data.result.status.status && data.result.status.status === defaultConst.constAPISuccess && data.result.profileId) {
        that.loginModal.handleHide();
        if (data && data.result && data.result.redirectToChangePassword && data.result.redirectToChangePassword === 'Yes') {
          const _url = serverClientUtil.getLPFullURL() + '/users/changePassword';

          const _dataLayer = that.getTaggingData(data, _url);
          that.tagging.applyGTM('Login', _dataLayer);

          window.location.href = _url;

          // eslint-disable-next-line no-undef
          dataLayer.push({
            event: 'Login',
            Login: 'No Logueado',
          });
        } else if (data && data.result && data.result.firstName && eventDetails && eventDetails.length > 1) {
          const _dataLayer = that.getTaggingData(data, applicationRoutes.multipleEvents);
          that.tagging.applyGTM('Login', _dataLayer);

          // eslint-disable-next-line no-undef
          dataLayer.push({
            event: 'Login',
            Login: 'Logueado',
          });

          browserHistory.push({ pathname: applicationRoutes.multipleEvents });
        } else if (data && data.result && data.result.firstName && eventDetails && eventDetails.length === 1) {
          const _url = commonUtil.routeTo(applicationRoutes.giftList, { eventID: eventDetails[0].eventId });
          const _dataLayer = that.getTaggingData(data, _url);
          that.tagging.applyGTM('Login', _dataLayer);

          // eslint-disable-next-line no-undef
          dataLayer.push({
            event: 'Login',
            Login: 'Logueado',
          });

          browserHistory.push(_url);
        } else if (window) {
          const _dataLayer = that.getTaggingData(data, '/');
          that.tagging.applyGTM('Login', _dataLayer);
          window.location.href = '/';

          // eslint-disable-next-line no-undef
          dataLayer.push({
            event: 'Login',
            Login: 'Logueado',
          });
        }
      } else if (data.result.status === 'failure' && data.result.errorMessage) {
        that.warning.setMessage(data.errorMessage);

        // eslint-disable-next-line no-undef
        dataLayer.push({
          event: 'Login',
          Login: 'No Logueado',
        });
      } else if (data.result && data.result.status && data.result.status.status === 'failure' && data.result.status.errorMessage) {
        that.warning.setMessage(data.result.status.errorMessage);

        // eslint-disable-next-line no-undef
        dataLayer.push({
          event: 'Login',
          Login: 'No Logueado',
        });
      }
    }

    if (this.validate()) {
      const { _handleUserLogin } = this.props; // eslint-disable-line no-shadow
      _handleUserLogin(this.loginForm).then(checkAuth);
    }
  }
  toggleRemeberMeMessage = () => {
    const autologinTooltip = document.querySelector('.' + this.autoLoginTooltipmodel.className);
    if (autologinTooltip.style.display === 'none') {
      autologinTooltip.style.display = 'block';
    } else {
      autologinTooltip.style.display = 'none';
    }
  }
  render() {
    const SignInButton = {
      type: 'button',
      value: 'Iniciar Sesión',
      autoFocus: false,
      style: 'btnPrimary size-ExtraLarge loginModal',
      onClickHandler: this.handleUserLogin,
    };
    const createAccountButton = {
      type: 'button',
      value: 'Crea tu cuenta',
      autoFocus: false,
      style: 'btnSecondary size-ExtraLarge loginModal',
      onClickHandler: this.redirectCreateAccountPage,
    };
    const rememberMeCheckBoxConfig = {
      displayName: 'Mantener mi Sesión activa',
      id: 'loginchk',
      name: '',
      value: '',
      disabled: '',
    };
    return (
      <ModalPopover header="INICIA SESIÓN" isModal="true" modalId="loginMRpopup" modalClass="bs-example-modal-sm" outerClass="modal-sm" ref={loginModal => this.loginModal = loginModal}>

        <React.Fragment>
          <Tagging ref={tagging => this.tagging = tagging} />
          <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
          <div className="row">
            <div className="col-xs-12">
              <label>Correo electrónico</label>
              <div className="formBlock">
                <TextInput
                  className="form-control"
                  htmlId="usuario"
                  name="User"
                  maxlength="100"
                  ref={login => this.login = login}
                  onKeyPress={this.handleLoginOnEnter}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <label>Contraseña</label>
              <div className="formBlock">
                <TextInput
                  className="form-control"
                  htmlId="loginContraseña"
                  name="password"
                  type="password"
                  ref={password => this.password = password}
                  onKeyPress={this.handleLoginOnEnter}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <InputButton buttonAttr={SignInButton} />
            </div>
          </div>
          {/* eslint-disable */}
          <div className="row">
            <div className="p-l-15 formBlock">
              <CheckBox displayName={rememberMeCheckBoxConfig.displayName} id={rememberMeCheckBoxConfig.id} ref={(e) => { this.userAutoLogingChk = e; }}>
                <a className="p-l-5" onClick={this.toggleRemeberMeMessage}>{this.props.label && commonUtil.getLabel(this.props.label.createLogin, 'login.detalla.link')}<i className="icon-caret_down" /></a>
              </CheckBox>
              <div className="homeSessionContainer" style={{ 'display': 'none' }} ref={(e) => { this.autoLoginTooltipmodel = e; }}>
                <div className="rememberMeContent">
                  <p>{this.props.label && commonUtil.getLabel(this.props.label.createLogin, 'createLogin.rememberme.header.content')} <i className="icon-tache closeContainer" onClick={this.toggleRemeberMeMessage} /></p>
                  <hr />
                  <p>{this.props.label && commonUtil.getLabel(this.props.label.createLogin, 'createLogin.rememberme.content1')}</p>
                  <p>{this.props.label && commonUtil.getLabel(this.props.label.createLogin, 'createLogin.rememberme.content2')}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-xs-12"><a className="primaryColorLink" onClick={this.clickHandlerForgotPassword} >¿Olvidaste tu contraseña?</a></div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <p>¿NUEVO EN LIVERPOOL.COM.MX?</p>
              <InputButton buttonAttr={createAccountButton} />
            </div>
          </div>
        </React.Fragment>
      </ModalPopover>
    );
  }

}
export default LoginModal;
